// Copyright ©️ 2026 eVolve MEP, LLC

import { dateOnly } from '@evolvemep/api-ts';
import { getDefaultZIndex } from '@mantine/core';
import type { CustomDateProps } from 'ag-grid-react';
import { parseISO } from 'date-fns';

import { DateInputWrapped } from 'components/Mantine/DateInputWrapped';
import { isNotNil } from 'helpers/isNotNil';

export const CustomDateComponent = ({ date, onDateChange }: CustomDateProps) => (
  <DateInputWrapped
    placeholder="mm/dd/yyyy"
    popoverProps={{
      withinPortal: true,
      classNames: {
        // Necessary for AG Grid to not close the filter
        // when we click on the popover
        dropdown: 'ag-custom-component-popup',
      },
      zIndex: getDefaultZIndex('popover') + 1,
    }}
    value={date ? dateOnly(date) : null}
    onChange={(v) => (isNotNil(v) ? onDateChange(parseISO(v)) : v)}
  />
);
